import {
  GET_ALL_ROLES,
  GET_PERMISSIONS,
  GET_ROLE,
  LOADING_ROLE,
  ERROR_ROLE,
  ADD_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE
} from "store/actions/roleAction";

export default (store = {}, action) => {
  switch (action.type) {
    case LOADING_ROLE:
      return {
        ...store,
        isLoadingRole: action.payload
      };
    case ERROR_ROLE:
      return {
        ...store,
        errorRole: action.payload
      };
    case GET_ALL_ROLES:
      return {
        ...store,
        getAllRoles: action.payload
      };
    case GET_PERMISSIONS:
      return {
        ...store,
        getPermissions: action.payload
      };
    case GET_ROLE:
      return {
        ...store,
        getRole: action.payload
      };
    case ADD_ROLE:
      return {
        ...store,
        addRole: action.payload
      };
    case UPDATE_ROLE:
      return {
        ...store,
        updateRole: action.payload
      };
    case DELETE_ROLE:
      return {
        ...store,
        deleteRoleStatus: action.payload
      };
    default:
      return store;
  }
};
